var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1HomeVideoMonitoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.84 4.61L6 25.3V66h65V25.31L38.84 4.61zM67 62H10V27.5L38.82 9.35 67 27.49V62zM31.84 21l-9.78 12.51L35 41.35V52H24v4h15V43.77l5 3 3.41-1.17 3.7 2.64 7.43-2.35-3.82-2.81 8-2.76L31.84 21zM28 32.43l4.77-6.09 20.8 13-9 3.11L28 32.43z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Home_video_monitoring.bfeb8284.svg";
export { SvgG1HomeVideoMonitoring as ReactComponent };